import constant from "config/constant";

const coinMap = constant.coins;

// console.log("COIN MAP", coinMap);

const isSupported = (coin) => Object.keys(coinMap).includes(coin);

const toPrecision = (
  number,
  coin,
  showUnit = true,
  precision = 8,
  forcePrecisionParam = false
) => {
  const utilsMap = {
    enactPrecision: (_precision) => Number(Number(number).toFixed(_precision)),
    enactPrecisionWithUnit: (_precision, _coin) =>
      `${Number(Number(number).toFixed(_precision))} ${String(_coin)}`,
  };

  utilsMap.enactUnit = (_precision, _coin) =>
    showUnit
      ? utilsMap.enactPrecisionWithUnit(_precision ?? precision, _coin)
      : utilsMap.enactPrecision(_precision);

  if (!isSupported(coin))
    return utilsMap.enactUnit(precision, String(coin).toUpperCase());

  return utilsMap.enactUnit(
    forcePrecisionParam ? precision : coinMap[coin]?.precision,
    coinMap[coin].label
  );
};

export default toPrecision;
